import { ImporterRun } from 'dashboard/models/importer-run';
import Action from 'lib/interfaces/Action';
import { PaginationParams } from 'lib/interfaces/api';

interface ImporterRunPayload {
  importerRun: ImporterRun;
}

interface ImporterRunsPayload {
  importerRuns: ImporterRun[];
  paginationParams: PaginationParams;
}

interface CurrentPagePayload {
  currentPage: number;
}

interface PageSizePayload {
  pageSize: number;
}

export type ImporterRunsActions =
  | Action<ImporterRunsActionType.SaveImporterRun, ImporterRunPayload>
  | Action<ImporterRunsActionType.SaveImporterRuns, ImporterRunsPayload>
  | Action<ImporterRunsActionType.SaveCurrentPage, CurrentPagePayload>
  | Action<ImporterRunsActionType.SavePageSize, PageSizePayload>;

export enum ImporterRunsActionType {
  SaveImporterRun = 'importer-runs/SAVE_IMPORTER_RUN',
  SaveImporterRuns = 'importer-runs/SAVE_IMPORTER_RUNS',
  SaveCurrentPage = 'importer-runs/SAVE_CURRENT_PAGE',
  SavePageSize = 'importer-runs/SAVE_PAGE_SIZE',
}

export function saveImporterRuns(importerRuns: ImporterRun[], paginationParams?: PaginationParams) {
  return {
    payload: {
      importerRuns,
      paginationParams,
    },
    type: ImporterRunsActionType.SaveImporterRuns,
  };
}

export function saveImporterRun(importerRun: ImporterRun) {
  return {
    payload: {
      importerRun,
    },
    type: ImporterRunsActionType.SaveImporterRun,
  };
}

export function saveCurrentPage(currentPage: number) {
  return {
    payload: {
      currentPage,
    },
    type: ImporterRunsActionType.SaveCurrentPage,
  };
}

export function savePageSize(pageSize: number) {
  return {
    payload: {
      pageSize,
    },
    type: ImporterRunsActionType.SavePageSize,
  };
}
